










































































































































































































































































































































import AdvancedSearch from '@/components/lookup/AdvancedSearch.vue'
import AdvancedSidebarSearch from '@/components/lookup/AdvancedSidebarSearch.vue'
import DataTable from '@/components/lookup/DataTable.vue'
import GMapPin from '@/components/lookup/GMapPin.vue'
import LoadItemMenu from '@/components/lookup/LoadItemMenu.vue'
import QuantumChart from '@/components/lookup/QuantumChart.vue'
import UnconfiguredGmapAlert from '@/components/UnconfiguredGmapAlert.vue'
import { authPermissions } from '@/constants'
import { EventBus, ON_SHOW_MAP, TRIGGER_SEARCH } from '@/eventbus'
import { mailMergeService, reportService } from '@/services'
import { GmapMarker, GmapRecord } from '@/types/gmapMixinType'
import { Report } from '@/types/ReportServiceType'
import { GmapRecordSetting, StackGmapIconSetting } from '@/types/StackGmapServiceType'
import { Filter, MenuItems, SearchConfigField, SearchOption } from '@/types/utilTypes'
import { generateGmapRecord, initGmaps, isFeatureAccessible, sessionGet, sessionSet, toIsoDateFormat } from '@/utils'
import dayjs from 'dayjs'
import { saveAs } from 'file-saver'
import { cloneDeep, debounce } from 'lodash'
import Vue from 'vue'

function generateInitialData() {
    return {
        records: [],
        markers: [] as GmapMarker[],
        totalRecords: 0,
        gmapRecords: [] as GmapRecord[]
    }
}

function generateInitialReportForm(source: string) {
    return {
        form: {
            source,
            name: '',
            settings: {} as SearchOption,
            isPublic: false,
            isOwned:  true
        },
        errors: {} as Record<string,string>,
        upsertDialog: false,
        deleteDialog: false,
        success: false,
        loading: false,
        deleteReport: {} as Report
    }
}

function generateBaseSearchOption(groupBy:any = []) {
    return {
        'isAdvancedSearch': false,
        'timeZoneOffsetInMinutes': -420,
        'searchFilters': [],
        'keywords': '',
        'pageSize': 100,
        'pageIndex': 1,
        'order': '',
        groupBy,
        'headerOrder': {},
        'aggregateFilters': []
    }
}

export default Vue.extend({
    name: 'Lookup',
    components: {
        AdvancedSearch,
        DataTable,
        GMapPin,
        LoadItemMenu,
        QuantumChart,
        UnconfiguredGmapAlert,
        AdvancedSidebarSearch
    },
    async mounted() {
        await this.getReports()
        await this.getRecords()
        EventBus.$on(TRIGGER_SEARCH,  this.getRecords)
        this.resizeUntilLoaded()

        this.mapsConfigLoading = true
        await initGmaps.call(this, this.$store.getters.currentPageConfig.gmapOptions)
        this.mapsConfigLoading = false

    },
    destroyed() {
        EventBus.$off()
    },
    created() {
        this.debouncedQuantumLoadData = debounce(this.quantumLoadData.bind(this), 500)
        const url = this.$route.query.q as string

        const session =  sessionGet(`${this.$store.getters.currentPageConfig.pageName}SearchOption`) as unknown as SearchOption
        const base:SearchOption = generateBaseSearchOption(this.$store.getters.currentPageConfig.defaultGroupBy ?? this.$store.getters.currentPageFields.map((x:any)=> x.alias))

        let temp:any = url && {
            ...base,
            isAdvancedSearch: Boolean(url),
            searchFilters: url ? (JSON.parse(decodeURIComponent(url))).fields : [],
        }

        if(temp?.searchFilters && temp.searchFilters.length > 0) {
            if(temp.searchFilters.length > 4) {
                temp.searchFilters.length = 4
            }

            for(let searchFilter of (temp.searchFilters as Filter[])) {
                searchFilter.id = Date.now().toString() + Math.random()
                searchFilter.nonFilterFields = {
                    datePickerMenu: false,
                    dateValue: '',
                    type: 'string'
                }

                const foundField = (this.$store.getters.currentPageFields as SearchConfigField[]).find( (field) => field.key === searchFilter.field)
                if(foundField) {
                    searchFilter.nonFilterFields.type = foundField.type
                    searchFilter.nonFilterFields.dateValue = toIsoDateFormat(searchFilter.value)
                }
            }
        }

        temp = {
            ...base,
            ...session,
            ...temp,
        }

        this.searchOption = temp as SearchOption
        if(sessionGet(`${this.$store.getters.currentPageConfig.pageName}Tab`)) {
            this.tab = parseInt(sessionGet(`${this.$store.getters.currentPageConfig.pageName}Tab`))
        }
        const loadedReportForm = this.getLoadedReportFromSessionStorage()
        if(loadedReportForm) {
            this.reportForm.form = loadedReportForm
            this.loadedReportName = loadedReportForm.name
        }
    },
    data() {
        return {
            tab: 0,
            ...generateInitialData(),
            searchOption: {} as SearchOption,
            sessionTimeout: 10080,
            pageLoading: false,
            highlightText: '',
            abortController: new AbortController(),
            gmapRecordSetting: {} as GmapRecordSetting,
            gmapIconSetting: {} as StackGmapIconSetting,
            isMapConfigured: false,
            mapsConfigLoading: false,
            contentHeight: '100%',
            dataTableHeight: 0,
            editorView: false,
            reportForm: generateInitialReportForm(this.$store.getters.currentPageConfig.pageName),
            storageReportFormKey: `${this.$store.getters.currentPageConfig.pageName}Report`,
            reports: {
                owned: [],
                public: [],
                loading: false
            } as MenuItems<Report>  ,
            loadedReportName: '',
            debouncedQuantumLoadData: () => undefined as any,
        }
    },
    watch: {
        searchOption:{
            handler(newValue){
                sessionSet(`${this.$store.getters.currentPageConfig.pageName}SearchOption`,newValue,this.sessionTimeout)
            },
            deep:true,
        },
        tab() {
            sessionSet(`${this.$store.getters.currentPageConfig.pageName}Tab`, this.tab, this.sessionTimeout)
            if(this.isMapView) {
                EventBus.$emit(ON_SHOW_MAP)
            }
            this.getRecords()
            this.resizeUntilLoaded()
        },
        editorView(newValue) {
            if(!newValue) {
                // To remove search filters that are hidden and retain searchfilters that are persistent
                const newSearchFilter = cloneDeep(this.searchOption.searchFilters).filter( filter =>
                    this.searchOption.groupBy.includes(filter.field) || this.persistentFilters.includes(filter.field))

                if(newSearchFilter.length === 0 ) {
                    newSearchFilter.push({
                        id: Date.now().toString(),
                        field: '',
                        operator: '',
                        value: '',
                        logic: 'and',
                        nonFilterFields: {
                            dateValue: '',
                            datePickerMenu: false,
                            type: ''
                        }
                    })
                }
                this.searchOption.searchFilters = newSearchFilter

                this.getRecords()
            }
        },
        // This watcher is used to handle the case where an aggregate field is shown as a column in the data table,
        // and then the user deletes that aggregate field.
        '$store.getters.aggregateFieldLabelsLookup': {
            handler() {
                for(let i = this.searchOption.groupBy.length - 1; i > -1; i--) {
                    const groupByField = this.searchOption.groupBy[i]
                    if(this.$store.getters.currentPageConfigExternalFields.aggregateFields[groupByField] &&  !this.$store.getters.aggregateFieldLabelsLookup[groupByField]) {
                        this.searchOption.groupBy.splice(i, 1)
                    }
                }
                
            }
        },
        // This watcher is used to handle case where a formula field is shown as a column in the data table, and the user deletes the formula field
        '$store.getters.formulaFieldLabelsLookup' : {
            handler() {
                for(let i = this.searchOption.groupBy.length - 1; i > -1; i--) {
                    const groupByField = this.searchOption.groupBy[i]
                    if(this.$store.getters.currentPageConfigExternalFields.formulaFields[groupByField] &&  !this.$store.getters.formulaFieldLabelsLookup[groupByField]) {
                        this.searchOption.groupBy.splice(i, 1)
                    }
                }

                for(let i = this.searchOption.searchFilters.length - 1; i > -1; i--) {
                    const searchFilter = this.searchOption.searchFilters[i]
                    if(this.$store.getters.currentPageConfigExternalFields.formulaFields[searchFilter.field] && !this.$store.getters.formulaFieldLabelsLookup[searchFilter.field]) {
                        this.searchOption.searchFilters.splice(i, 1)
                        if(this.searchOption.searchFilters.length === 0) {
                            this.searchOption.searchFilters.push({
                                id: Date.now().toString(),
                                field: '',
                                operator: '',
                                value: '',
                                logic: 'and',
                                nonFilterFields: {
                                    dateValue: '',
                                    datePickerMenu: false,
                                    type: ''
                                }
                            })
                        }
                    }
                }
            }
        }
    },
    methods: {
        resizeUntilLoaded() {
            const toolbarElement = document.querySelector('.v-toolbar')?.clientHeight ?? 0
            if(toolbarElement === 0) {
                setTimeout(() => {  this.resizeUntilLoaded()})
            } else {
                setTimeout(() => {  this.handleResize()})
            }
        },
        handleResize() {
            const toolbarElement = document.querySelector('.v-toolbar')?.clientHeight ?? 64
            const footerElement = document.querySelector('.v-footer')?.clientHeight ?? 36
            const tabs = document.querySelector('.v-tabs')?.clientHeight ?? 0
            const actionButtons = document.querySelector('.action-btns')?.clientHeight ?? 0
            const pagination = document.querySelector('.pagination')?.clientHeight ?? 0
            const keywordSearchContainer = document.querySelector('.keyword-search-container')?.clientHeight ?? 0

            let contentHeight = window.innerHeight - toolbarElement - footerElement

            this.contentHeight = this.$vuetify.breakpoint.xsOnly ? '90vh' : `${contentHeight}px`
            this.dataTableHeight = contentHeight - tabs - actionButtons - pagination - keywordSearchContainer - 50
        },
        onSearchOptionChange(value: Record<keyof SearchOption, any>, shouldSearch = false){
            this.searchOption =  cloneDeep({ ...{aggregateFilters: []}, ...this.searchOption, ...value})
            if(shouldSearch) {
                this.getRecords()
            }

        },
        addFilter([field,value]:string[]){
            this.searchOption.pageIndex = 1
            const url = this.$route.query.q as string ?? ''
            const decodedQuery = decodeURIComponent(url)

            //  @ts-ignore
            this.$refs.advancedSearch.addQuickFilter(field,value)
            const query =  JSON.stringify({fields:this.searchOption.searchFilters})

            if(decodedQuery !== query){
                this.$router.push({query:{
                    q:query
                }})
            }

        },
        async exportRecords() {
            let selectedMarkers = this.markers.filter(o=>o.isSelected).map(o=>o.id).join(',')
            let searchOption = selectedMarkers.length > 0 ? {
                'isAdvancedSearch': true,
                'timeZoneOffsetInMinutes': -420,
                'searchFilters': [
                    {field: this.$store.getters.currentPageConfig.gmapOptions.exportIdField, operator: 'in', value: selectedMarkers, logic: 'and'}
                ],
                'keywords': '',
                'pageSize': 0,
                'pageIndex': 0,
                'order': '',
                'groupBy': this.searchOption.groupBy
            } : null


            try {

                const res = await this.axios.post(
                    this.$store.getters.currentPageConfig.exportApi.api,
                    searchOption? searchOption : this.searchOption,
                    {responseType: 'blob'}
                )
                const fileNamePrefix = this.loadedReportName || `${this.$store.getters.currentPageConfig.pageName}_Export`
                const fileName = `${fileNamePrefix}_${dayjs().format('YYYY-MM-DD_HHmmss')}.xlsx`

                saveAs(res.data,fileName)
            } catch (err) {
                console.log(err)
            }
        },
        async getRecords(){
            this.abortController.abort()
            this.pageLoading = true
            this.abortController = new AbortController()

            const initialData = generateInitialData()
            this.records = initialData.records
            this.markers = initialData.markers
            this.totalRecords = initialData.totalRecords
            this.gmapRecords = initialData.gmapRecords

            try {
                if(this.isQuantumChartView) {
                    this.debouncedQuantumLoadData()
                    this.pageLoading = false
                    return
                }

                const res = await this.axios.post(
                    this.$store.getters.currentPageConfig.api,
                    this.searchOption,
                    {
                        signal: this.abortController.signal
                    }
                )

                if(this.isMapView) {
                    this.gmapRecords = (res.data.records || []).map((record: any) => generateGmapRecord({
                        recordSetting: this.gmapRecordSetting,
                        dynamicObj: record,
                        id: record[this.$store.getters.currentPageConfig.gmapOptions.idFieldKey],
                        gmapIconSetting: this.gmapIconSetting,
                        enableUrl: !!record[this.$store.getters.currentPageConfig.gmapOptions.idFieldKey]
                    }))

                } else {
                    this.records = res.data.records

                    this.highlightText = this.searchOption.isAdvancedSearch ? '' : this.searchOption.keywords
                }

                this.totalRecords = res.data.totalRecords
                this.pageLoading = false

                if(this.searchOption.pageIndex > Math.ceil( this.totalRecords / this.searchOption.pageSize) && this.searchOption.pageIndex > 1) {
                    this.searchOption.pageIndex = 1
                    this.getRecords()
                }
            } catch (err) {
                if(!this.axios.isCancel(err)) {
                    this.pageLoading = false
                }
            }
        },
        async onSearch() {
            this.searchOption.pageIndex = 1
            await this.getRecords()
        },
        async onSaveReport() {
            this.reportForm.loading = true
            this.reportForm.errors = {}
            this.reportForm.success = false

            try{
                this.reportForm.form.settings = this.searchOption
                await reportService.upsertReport(this.reportForm.form)
                await this.getReports()
                this.reportForm.success = true
            }catch (e) {
                if(this.axios.isAxiosError(e) && e?.response?.status == 400 && e.response.data && e.response.data.errors) {
                    for (const [key, value] of Object.entries(e.response.data.errors)) {
                        this.reportForm.errors[key] = value as string
                    }

                    this.reportForm.errors.General = 'There are errors that require your attention'
                } else {
                    this.reportForm.errors.General = 'We\'re sorry, but we can\'t process your request at this time. Please try again later.'
                }
            }
            this.reportForm.loading = false
            if(this.reportForm.success) {
                this.saveReportToSessionStorage()
            }

        },
        async getReports() {
            try{

                this.reports.loading = true
                this.reports.owned = []
                this.reports.public = []

                const resp = await reportService.getReports(this.$store.getters.currentPageConfig.pageName)
                resp.forEach( report => {
                    if(report.isOwned) {
                        this.reports.owned.push(report)
                    } else {
                        this.reports.public.push(report)
                    }

                })

                this.reports.loading = false
            } catch(e) {
                this.reports.loading = false
                console.error(e)
            }
        },
        onSaveReportCancel() {
            let formCopy = this.reportForm.form
            let isSuccess = this.reportForm.success

            this.reportForm = generateInitialReportForm(this.$store.getters.currentPageConfig.pageName)
            if(isSuccess) {
                this.loadedReportName = formCopy.name
            }
            this.reportForm.form = formCopy
        },
        async onDeleteReport() {
            this.reportForm.loading = true
            this.reportForm.errors = {}
            this.reportForm.success = false

            try{
                await reportService.deleteReport(this.reportForm.deleteReport)
                this.reportForm.success = true
                await this.getReports()
            } catch(e) {
                this.reportForm.errors.General = 'There Are errors that require your attention'
            }
            this.reportForm.loading = false
        },
        onChooseDeleteReport(report: Report){
            this.reportForm.deleteReport = report
            this.reportForm.deleteDialog = true
        },
        saveReportToSessionStorage() {
            sessionSet(this.storageReportFormKey, this.reportForm.form)
        },
        async onLoadReport(report: Report) {
            this.reportForm.form = cloneDeep(report)

            if(!this.reportForm.form.isOwned) {
                this.reportForm.form.isPublic = false
            }

            const clonedSetting = cloneDeep(report.settings)
            if(!clonedSetting.headerOrder) {
                clonedSetting.headerOrder = {}
            }

            if(!clonedSetting.aggregateFilters) {
                clonedSetting.aggregateFilters = []
            }

            this.searchOption = clonedSetting
            this.saveReportToSessionStorage()
            this.loadedReportName = report.name
            await this.getRecords()
        },
        async onResetGrid() {
            this.clearReportState()
            await this.getRecords()
        },
        getLoadedReportFromSessionStorage() {
            return sessionGet(this.storageReportFormKey) as any
        },
        async onHideAllColumns() {
            this.searchOption.groupBy = []
            await this.getRecords()
        },
        async quantumDataLoad() {
            return (await this.axios.post(this.$store.getters.currentPageConfig.quantumChartsApi.api, { ...this.searchOption, pageSize: -1 }, {
                signal: this.abortController.signal
            })).data

        },
        clearReportState(){
            this.reportForm = generateInitialReportForm(this.$store.getters.currentPageConfig.pageName)
            this.searchOption = generateBaseSearchOption(this.$store.getters.currentPageFields.map((x:any)=> x.alias))
            this.loadedReportName = ''
            sessionStorage.removeItem(this.storageReportFormKey)
        },
        quantumLoadData() {
            setTimeout(() => {
                const popConnQChart = this.$refs.propConnQChart as any
                if(popConnQChart && popConnQChart.$refs.qchart)
                {
                    popConnQChart.$refs.qchart.loadData()
                }
            }, 500)
        },
        async onTemplateReplace(record: Record<string,string>, id: string, fileName: string) {
            try {
                const result = await mailMergeService.templateReplace(record, id)
                // Handle the result as needed
                saveAs(result.data, fileName)
            } catch (error) {
                // Handle the error as needed
            }
        }
    },
    computed: {
        isListView(): boolean {
            return this.tab === 0
        },
        isMapView(): boolean {
            return this.tab === 1
        },
        isQuantumChartView() : boolean {
            return this.tab === 2
        },
        canAccessQuantumCharts(): boolean {
            return this.$store.getters.currentPageConfig.quantumChartsApi && isFeatureAccessible(this.$store.getters.currentPageConfig.quantumChartsApi.requiredPermissions, this.$store.getters.user.permissions)
        },
        canUseExportFeature(): boolean {
            return this.$store.getters.currentPageConfig.exportApi && isFeatureAccessible(this.$store.getters.currentPageConfig.exportApi.requiredPermissions, this.$store.getters.user.permissions) && this.searchOption.groupBy.length > 0
        },
        canManageMailMerge(): boolean {
            return this.$store.getters.currentPageConfig.enableMailMerge && isFeatureAccessible([authPermissions.canManageMailMerge], this.$store.getters.user.permissions)
        },
        canAccessMailMerge(): boolean {
            return this.$store.getters.currentPageConfig.enableMailMerge && isFeatureAccessible([authPermissions.canAccessMailMerge], this.$store.getters.user.permissions)
        },
        persistentFilters(): string[] {
            return this.$store.getters.currentPageFields.filter((field: any) => field.showPersistently).map((field:any) => field.alias)
        }
    }
})
